import client from "../api-client";
import toQueryString from "../toQueryString";

const URL = "todo.php";

export var list = [];

export const defaultPriority = 1;

export const createTask = {
  uid: "",
  title: "",
  status: 0,
  aid: 0,
  priority: defaultPriority,
};

export const get = async (uid) => {
  let params = toQueryString({ id: uid });
  return await client(URL + `?${params}`).then(async (response) => {
    list = response;
    return list;
  });
};

export const add = async (task) => {
  return await client(URL, {
    method: "PUT",
    body: {
      ...createTask,
      ...task,
    },
  }).then(async (response) => {
    list.push(response);
    return response;
  });
};

export const remove = async (todo) => {
  let params = toQueryString({ id: todo.id });
  return await client(URL + `?${params}`, {
    method: "DELETE",
  }).then(async (response) => {});
};

export const markDone = async (todo) => {
  todo.status = todo.status === "1" ? 0 : 1;
  let params = toQueryString({ action: "markDone" });
  return await client(URL + `?${params}`, {
    method: "POST",
    body: todo,
  }).then(async (response) => {
    list.map((obj) => {
      if (obj.id === todo.id) {
        obj.status = obj.status === 1 ? 0 : 1;
      }

      return obj;
    });

    return list;
  });
};

export const setPriority = async (item, priority) => {
  item.priority = priority;

  let params = toQueryString({ action: "setPriority" });

  return await client(URL + `?${params}`, {
    method: "POST",
    body: item,
  }).then(async (response) => {
    list.map((obj) => {
      if (item.id === obj.id) {
        obj.priority = priority;
      }

      return obj;
    });

    return list;
  });
};

export const assignUser = async (item, user) => {
  item.aid = user.aid;

  let params = toQueryString({ action: "assignUser" });

  return await client(URL + `?${params}`, {
    method: "POST",
    body: item,
  }).then(async (response) => {
    list.map((obj) => {
      if (item.id === obj.id) {
        item.aid = user.aid;
      }

      return obj;
    });

    return list;
  });
};
